import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalBackComponent(props) {
  const { t } = useTranslation();

  const handleHideModal = () => {
    window.history.pushState(null, null, window.location.pathname);
    props.closeModal();
  };

  return (
    <Modal id="backBooking" centered show={props.showBack} onHide={handleHideModal} backdrop="static">
      <div className="back-modal">
        <div className="back-modal__title pb-3">{t('payment.label_backModalTitle')}</div>
        <div>{t('payment.label_backModalDesc1')}</div>
        <div className="pb-3">{t('payment.label_backModalDesc2')}</div>
        <div className="d-flex justify-content-end back-modal__button">
          <input
            type="button"
            value={t('payment.label_buttonCancel')}
            onClick={handleHideModal}
            className="back-modal__button-cancel"
          />
          <input
            type="button"
            value={t('payment.label_buttonContinue')}
            className="back-modal__button-continue"
            onClick={() => props.prev()}
          />
        </div>
      </div>
    </Modal>
  );
}

export default ModalBackComponent;
